.gh-version-switcher select {
  max-width: 196px;
}
